import { render, staticRenderFns } from "./homeLayout.vue?vue&type=template&id=0bd277d2&scoped=true&"
import script from "./homeLayout.vue?vue&type=script&lang=ts&"
export * from "./homeLayout.vue?vue&type=script&lang=ts&"
import style0 from "./homeLayout.vue?vue&type=style&index=0&id=0bd277d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd277d2",
  null
  
)

export default component.exports